import { ALLOWED_FILE_TYPES, MAX_FILE_SIZE } from '../model/data';

export const validateFile = (file: File, setter: (error: string) => void): boolean => {
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        setter('Разрешены только файлы в формате PNG, JPG');

        return false;
    }

    if (file.size > MAX_FILE_SIZE) {
        setter('Размер файла не должен превышать 5 МБ');

        return false;
    }

    return true;
};
